export default __webpack_public_path__ + "static/media/title-landing.f74e92f0.png";